<template>
  <div class="video-page">
    <div class="login-header" style=" box-shadow: 1px 1px 15px rgb(0 0 0 / 10%); height: 50px;
    line-height: 70px;height: 70px;
    padding: 0 20px 0 40px;position:fixed;z-index:999;left:0;right:0;background-color:  #0D2246;height: 70px;">
      <!-- <div style="background-color: #fff; box-shadow: 1px 1px 15px rgb(0 0 0 / 10%); height: 50px;
    line-height: 60px;height: 60px;
    padding: 0 20px 0 40px;position:fixed;z-index:999;left:0;right:0;"> -->
      <div class="goBack" @click="goToBack()" style="top: 0px;"><i class="el-icon-back" style="color: #D6DFE7;"></i>
      </div>
      <el-row type="flex" justify="center" align="center">
        <el-col :xs="24">
          <div class="headerMain">
            <div style="display:flex;">
              <!-- <img src="@/assets/img/logo.jpg" alt="logo" style="width: 60px ;height:60px;" />
              <div class="headerTop">考试视频回放</div> -->
              <!-- <img src="@/assets/addImg/logo1.png" alt="logo"
                style="width: 597px ;height:36px;line-height: 70px;margin-top: 15px;" /> -->
              <img src="@/assets/addImg/logo2.png" alt="logo"
                style="width: 597px ;height:36px;line-height: 70px;margin-top: 15px;" />
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div style="height: 70px;"></div>

    <div style="display:flex;justify-content: center;align-items: center;">
      <div v-for="(tab, index) in tabList" :key="index" :style="{
        width: '130px',
        height: '48px',
        margin: '20px 8px',
        textAlign: 'center',
        position: 'relative',
        cursor: 'pointer',
        color: tab.selected ? '#75FFF7' : 'inherit',
      }" @click="selectTab(index)">
        <img :src="tab.selected ? tabActiveImage : tabDefaultImage" alt="icon"
          style="width: 100%; height: 100%; vertical-align: middle;" />
        <span style="vertical-align: middle;position: absolute;left:0;right:0;top:14px;">{{ tab.name }}</span>
      </div>

    </div>

    <div v-show="videoLength == 1">
      <div v-for="(video, idx) in videos" :key="idx">
        <div v-if="video.type === 'image'" class="thumbnail-container bg_img_1" style="margin-top: 120px !important;">
          <el-image class="thumbnail" fit="cover" :src="video.thumbnail" :preview-src-list="[video.thumbnail]">
          </el-image>
          <div class="video-name">{{ video.name }}</div>
        </div>
        <div v-else class="thumbnail-container bg_img_1"  style="margin-top: 120px !important; " @click="openVideoDialog(video)">
          <img :src="video.thumbnail" class="thumbnail" />
          <div class="video-name">{{ video.name }}</div>
        </div>
      </div>
    </div>

    <div v-show="videoLength == 2" style="display:flex;justify-content: center;align-items: center;">
      <div v-for="(video, idx) in videos" :key="idx">
        <div v-if="video.type === 'image'" class="thumbnail-container bg_img_1" style="width: 100%;">
          <el-image class="thumbnail" fit="cover" :src="video.thumbnail" :preview-src-list="[video.thumbnail]">
          </el-image>
          <div class="video-name">{{ video.name }}</div>
        </div>
        <div v-else class="thumbnail-container bg_img_1" style="width: 100%;" @click="openVideoDialog(video)">
          <img :src="video.thumbnail" class="thumbnail" />
          <div class="video-name">{{ video.name }}</div>
        </div>
      </div>
    </div>

    <swiper v-if="videoLength > 2" :options="swiperOptions" ref="mySwiper" style="margin-top: 10px;" :key="swiperKey">
      <swiper-slide v-for="(video, idx) in videos" :key="idx">
        <div v-if="video.type === 'image'" class="thumbnail-container bg_img_1" style="margin-top: 40px;width:100%;">
          <el-image class="thumbnail" fit="cover" :src="video.thumbnail" :preview-src-list="[video.thumbnail]">
          </el-image>
          <div class="video-name">{{ video.name }}</div>
        </div>
        <div v-else class="thumbnail-container bg_img_1" style="margin-top: 40px;width:100%;"
          @click="openVideoDialog(video)">
          <img :src="video.thumbnail" class="thumbnail" />
          <div class="video-name">{{ video.name }}</div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>


    <el-tabs v-model="activeTab" @tab-click="handleTabClick" style="margin-top: 10px;" v-show="false">
      <el-tab-pane v-for="(tab, index) in tabs" :key="index" :label="tab" :name="String(index)">
        <el-row :gutter="20">
          <el-col v-for="(video, idx) in videos" :key="idx" :xs="24" :sm="12" :md="8" :lg="6" :xl="4"
            class="video-item">
            <div v-if="video.type === 'image'" class="thumbnail-container bg_img_1">
              <el-image class="thumbnail" fit="cover" :src="video.thumbnail" :preview-src-list="[video.thumbnail]">
              </el-image>
              <div class="video-name">{{ video.name }}</div>
            </div>
            <div v-else class="thumbnail-container bg_img_1" @click="openVideoDialog(video)">
              <img :src="video.thumbnail" class="thumbnail" />
              <div class="video-name">{{ video.name }}</div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <el-dialog :visible.sync="dialogVisible" :fullscreen="true" :show-close="true" :close-on-click-modal="true"
      @close="handleDialogClose">
      <div class="dialog-video-container">
        <video ref="videoPlayer" :src="selectedVideo?.url" controls autoplay class="dialog-video"
          @ended="onVideoEnded"></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css'; // 引入核心样式
// import { Swiper, SwiperSlide } from 'swiper';
// // import 'swiper.less';

import tabDefaultImage1 from '@/assets/addImg/video-play/t0.png';
import tabDefaultImage2 from '@/assets/addImg/video-play/t1.png';

export default {
  name: 'VideoPlay',
  // comments: {
  //   Swiper,
  //   SwiperSlide,
  // },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  data() {
    return {
      tabDefaultImage: tabDefaultImage1,
      tabActiveImage: tabDefaultImage2,
      tabList: [],
      vList: [],
      videoLength: 0,
      swiperKey: 0,
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: true,
        // loop: true,
        // slidesPerGroup: 3,
        // loop: true,
        // observer: true,
        // observeParents: true,
        // loopFillGroupWithBlank: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        //  on: {
        //   // 监听 slide 创建事件
        //   slideChange: function () {
        //     // 确保内容正确渲染
        //     this.$nextTick(() => {
        //       this.updateLoopSlides();
        //     });
        //   },
        // },
      },
      swiperInstance: null,
      // tab 标签
      tabs: [
        // '1.考务会',
        // '2.试卷清点',
        // '3.试卷发放',
        // '4.入场核验',
        // '5.调度画面',
        // '6.收卷',
        // '7.突发',
      ],
      activeTab: '0', // 默认激活第一个 tab
      videos: [], // 当前 tab 下的视频列表
      selectedVideo: null, // 当前选中的视频
      configData: null,
      dialogVisible: false, // 控制弹框是否显示
    };
  },
  methods: {
    updateLoopSlides() {
      const swiper = this.$refs.mySwiper?.swiper;
      if (!swiper) return;

      // 获取所有 slide 元素
      const slides = swiper.slides;

      // 遍历所有 slide（包括复制的 slide）
      slides.forEach((slide, index) => {
        // 获取原始数据索引（假设原始数据长度为 originalLength）
        const originalIndex = index % this.videos.length;

        // 更新 slide 内容（根据业务逻辑动态填充）
        const slideContent = slide.querySelector('.thumbnail-container');
        if (slideContent) {
          // 重新绑定数据（如 video.name）
          slideContent.querySelector('.video-name').innerText = this.videos[originalIndex]?.name || '';
        }
      });
    },
    selectTab(index) {
      this.tabList.forEach((tab, i) => {
        tab.selected = i === index;
      });
      this.loadVideos(index);
    },
    goToBack() {
      this.$router.go(-1);
    },
    openVideoDialog(video) {
      console.log(video)
      if (video.type === 'image') {
        return false
      }
      this.selectedVideo = video;
      this.dialogVisible = true;
    },

    // 关闭弹框时停止播放
    handleDialogClose() {
      const videoPlayer = this.$refs.videoPlayer;
      if (videoPlayer) {
        videoPlayer.pause(); // 停止播放
      }
      this.selectedVideo = null;
    },

    // 可选：视频结束时处理
    onVideoEnded() {
      console.log('视频已结束');
    },
    loadConfig() {
      const configUrl = '/videos/config.json';

      fetch(configUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error('网络响应失败');
          }
          return response.json();
        })
        .then(data => {
          console.log('读取到的配置:', data);
          // 处理你的数据
          this.configData = data;

          // 将 configData 中的 description 赋值给 tabs
          this.tabs = data.map(item => item.description);

          data.forEach((item, index) => {
            this.tabList.push({
              name: item.description,
              selected: index === 0 || false, // 默认选中第一个 tab
            });
          });

          this.loadVideos(0); // 初始化加载第一个 tab 的视频
        })
        .catch(error => {
          console.error('读取 config.json 失败:', error);
        });
    },
    // 获取当前 tab 对应的视频目录
    getVideoDir(tabIndex) {
      return `/videos/${parseInt(tabIndex) + 1}`;
    },

    // 加载视频列表
    loadVideos(tabIndex = 0) {
      const dir = this.getVideoDir(tabIndex);
      console.log(`加载视频目录11: ${dir}`)
      // configData 数据为
      // [
      //   {
      //     "dirname": "1",
      //     "description": "考务会",
      //     "files": [
      //       {
      //         "name": "24216-340670744_tiny",
      //         "path": "/videos/1/24216-340670744_tiny.mp4"
      //       },
      //       {
      //         "name": "74888-553838564_large",
      //         "path": "/videos/1/74888-553838564_large.mp4"
      //       }
      //     ]
      //   }
      // ]



      console.log('122', this.configData)
      const dirData = this.configData.find(item => item.dirname === (parseInt(tabIndex) + 1).toString());
      if (dirData) {
        // this.videos = dirData.files.map(file => ({
        //   name: file.name,
        //   url: file.path,
        //   thumbnail: '/default-thumbnail.jpg', // 可替换为动态生成缩略图
        // })); 

        const videosWithThumbnails = dirData.files.map(file => {
          console.log('file:', file)
          if (file.thumbnail) {
            return {
              name: file.name,
              url: file.path,
              thumbnail: file.thumbnail,
              type: file.type || 'video', // 添加 type 字段，默认为 video
            };
          } else {
            const video = {
              name: file.name,
              url: file.path,
              thumbnail: '',
              type: file.type || 'video',
            };

            const videoElement = document.createElement('video');
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            videoElement.src = video.url;

            videoElement.addEventListener('loadeddata', () => {
              videoElement.currentTime = 0;
            });

            videoElement.addEventListener('seeked', () => {
              canvas.width = videoElement.videoWidth;
              canvas.height = videoElement.videoHeight;
              ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
              const thumbnail = canvas.toDataURL('image/png');

              // 更新对应的视频对象
              this.videos = this.videos.map(v =>
                v.name === video.name ? { ...v, thumbnail } : v
              );
            });

            return video;
          }
        });

        // this.videos = videosWithThumbnails;

        this.$set(this, 'videos', videosWithThumbnails);

        console.log('加载的视频列表:', this.videos);
        console.log('数量:', this.videos.length);
        this.videoLength = this.videos.length;

        this.vList = []
        this.$set(this, 'vList', videosWithThumbnails);
        console.log('vList:', this.vList);
        console.log('vList leng :', this.vList.length);

        this.swiperKey++; // 更新 key 强制刷新 Swiper
        console.log('swiperKey:', this.swiperKey);
        // this.$nextTick(() => {
        //   if (this.$refs.mySwiper) {
        //     this.$refs.mySwiper.update(); // 手动刷新 Swiper
        //     console.log(111)
        //     setTimeout(() => {
        //       this.updateLoopSlides()    
        //     }, 50)
            
        //   }
        // });


      }

      // fetch(dir)
      //   .then(async (res) => {
      //     console.log('res:', res);
      //     if (res.status === 404) {
      //       console.warn(`目录不存在: ${dir}`);
      //       this.videos = [];
      //       return;
      //     }
      //     const html = await res.text();
      //     console.log('html:', html);
      //     const parser = new DOMParser();
      //     const doc = parser.parseFromString(html, 'text/html');
      //     const links = Array.from(doc.querySelectorAll('a'))
      //       .map((a) => a.getAttribute('href'))
      //       .filter((href) => href?.endsWith('.mp4'));

      //     console.log('links:', links)

      //     this.videos = links.map((file) => ({
      //       name: file,
      //       url: `${dir}/${file}`,
      //       thumbnail: '/default-thumbnail.jpg', // 可替换为动态生成缩略图
      //     }));
      //   })
      //   .catch((err) => {
      //     console.error('加载视频失败:', err);
      //     this.videos = [];
      //   });
    },

    // 切换 tab
    handleTabClick(tab) {
      this.loadVideos(parseInt(tab.name));
    },

    // 播放视频
    playVideo(video) {
      this.selectedVideo = video;
    },
  },
  created() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  mounted() {
    this.loadConfig();
  },
};
</script>

<style lang="scss">
.video-page {
  .el-tabs__item {
    font-size: 16px !important;
    color: #CDD6E3 !important;
  }

  .el-tabs__item.is-active {
    color: #3876ff !important;
  }
}
</style>
<style scoped>
.video-page {
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
  background-image: url('../../assets/addImg/video-play/bg1.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.swiper-container {
  width: 100%;
  height: 600px;
}

.swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  /* background: #fff; */

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.8);
  /* transform: scale(1); */

  padding: 0 0 !important;
}

.swiper-slide-active,
.swiper-slide-duplicate-active {
  /* transform: scale(1.1); */
  transform: scale(1);
}

.video-page {
  padding: 0 20px 20px 20px;
  color: #CDD6E3;
}

.thumbnail-container {
  text-align: center;
  cursor: pointer;
  margin-bottom: 15px;
  /* border: 2px solid yellow; */
  /* margin-top: 100px; */
}

.bg_img_1 {
  width: 33%;
  /* height: 480px; */
  height: 420px;
  margin: 0 auto;
  /* border: 2px solid red; */

  /* background-image: url('../../assets/addImg/video-play/bg2.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat; */

  margin-top: 40px !important;
}

.thumbnail {
  width: 100%;
  /* height: auto; */
  /* height: 440px; */
  height: 420px;
  /* height: 300px; */
  /* border-radius: 8px;
  padding-top: 100px;
  padding-left: 36px;
  padding-bottom: 46px;
  padding-right: 40px; */
  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); */
  /* border: 2px solid red; */
}

.video-name {
  margin-top: 20px;
  font-size: 18px;
  color: #00E8F9;
  padding-top: 26px;

  text-align: center;
  /* width: 33%; */
  width: 80%;
  height: 80px;
  margin: 0 auto;
  /* border:1px solid red; */
  /* border: 2px solid red; */

  /* background-image: url('../../assets/addImg/video-play/bg31.png'); */
  /* background-size: contain;
  background-position: center;
  background-repeat: no-repeat; */

  /* margin-top: 20px !important; */
}

.video-player {
  margin-top: 30px;
}

.player {
  width: 100%;
  max-width: 800px;
  height: auto;
}

.dialog-video-container {
  position: relative;
  width: 100%;
  /* height: 70vh; */
  height: calc(100vh - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-video {
  /* width: 100%;
  height: auto;
  max-height: 70vh; */

  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 视频自适应容器，保持比例，裁剪多余部分 */
  display: block;
}
</style>